<button
    *ngIf="!dataToUpdate && (hasCreatePermission | async)"
    class="btn btn-add px-5"
    (click)="analyticsService.analyticsCapture('click_add_expense', { lugar: location }); open(modalAddFixedVariableExpense, { size: 'md', centered: true })"
    [ngClass]="{ 'btn-add-compact': compactMode }"
>
    <span *ngIf="!compactMode">Agregar gasto</span>
    <span *ngIf="compactMode">+ Gasto</span>
</button>

<div *ngIf="dataToUpdate && ((hasUpdatePermission | async) || (hasDeletePermission | async))">
    <button *ngIf="expenseForm.get('type')?.value === 'fixed' && (hasUpdatePermission | async)" class="btn w-100 btn-purple mb-2" (click)="open(modalMessageEdit, { size: 'lg', centered: true })">
        Editar
    </button>
    <button *ngIf="hasDeletePermission | async" class="btn w-100 btn-danger" (click)="open(modalDeleteFixedVariableExpense, { size: 'md', centered: true })">Eliminar</button>
</div>

<form [formGroup]="expenseForm">
    <ng-template #modalAddFixedVariableExpense let-modal>
        <div class="modal-header">
            <div class="modal-title">{{ dataToUpdate ? 'Editar' : 'Agregar' }} gasto</div>
            <div class="box-btn-close-modal">
                <button (click)="modal.close('Close Click')" class="btn-close-modal rounded-circle" type="button" data-dismiss="modal" aria-label="Close">
                    <img src="assets/icons/svg/icon-btn-close-modal.svg" alt="Cerrar formulario de gastos fijos/variables" />
                </button>
            </div>
        </div>
        <div class="modal-body">
            <!-- Campo para el tipo de gasto -->
            <div class="row pb-3">
                <div class="col-12 col-md-6">
                    <div
                        class="card py-3 ps-3 rounded-3"
                        [ngClass]="{
                            'shadow-none': expenseForm.get('type')?.value !== 'variable',
                            'shadow-sm': expenseForm.get('type')?.value === 'variable',
                            'disabled-card': dataToUpdate
                        }"
                        (click)="!dataToUpdate && onChangeType('variable')"
                    >
                        <div class="form-check box-input-check">
                            <input class="form-check-input" type="radio" name="type" formControlName="type" id="checkTypeVariable" value="variable" (change)="onChangeType('variable')" />
                            <label class="form-check-label input-label mb-0" for="checkTypeVariable">
                                <strong>Gasto Variable</strong>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div
                        class="card py-3 ps-3 rounded-3"
                        [ngClass]="{
                            'shadow-none': expenseForm.get('type')?.value !== 'fixed',
                            'shadow-sm': expenseForm.get('type')?.value === 'fixed'
                        }"
                        (click)="!dataToUpdate && onChangeType('fixed')"
                    >
                        <div class="form-check box-input-check">
                            <input class="form-check-input" type="radio" name="type" formControlName="type" id="checkTypeFixed" value="fixed" (change)="onChangeType('fixed')" />
                            <label class="form-check-label input-label mb-0" for="checkTypeFixed">
                                <strong>Gasto Fijo</strong>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Campo Nombre -->
                <div class="col-sm-6 mb-3 box-field">
                    <label class="input-label" for="name">Nombre del gasto</label>
                    <input
                        class="form-control box-input"
                        type="text"
                        id="name"
                        name="name"
                        formControlName="name"
                        autocomplete="off"
                        [ngClass]="{ 'is-valid': isValidField(expenseForm, 'name'), 'is-invalid': isInvalidField(expenseForm, 'name') }"
                    />
                    <div class="invalid-feedback" *ngIf="expenseForm.get('name')?.hasError('required')">Debe asignar un nombre para el gasto.</div>
                </div>
                <!-- Categoría de gasto -->
                <div class="col-sm-6 mb-3 box-field">
                    <label for="formCategory" class="input-label">Categoría</label>
                    <div class="input-group">
                        <select
                            class="input-group form-select form-control rounded box-input"
                            id="formCategory"
                            name="formCategory"
                            formControlName="category"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'category'), 'is-invalid': isInvalidField(expenseForm, 'category') }"
                        >
                            <option selected value="">Seleccione...</option>
                            <option *ngFor="let category of categories" [value]="category" (click)="analyticsService.analyticsCapture(dataToUpdate ? 'edit' : 'add' + '_expense_category')">
                                {{ category | titlecase }}
                            </option>
                        </select>
                        <div class="invalid-feedback" *ngIf="isInvalidField(expenseForm, 'category')">Debe seleccionar una categoría.</div>
                    </div>
                </div>
            </div>
            <!-- Campo Monto -->
            <div class="row">
                <div class="col-sm-6 mb-3 box-field" *ngIf="expenseForm.get('type')?.value === 'fixed'">
                    <label class="input-label" for="amount">Monto en USD</label>
                    <div class="input-group">
                        <input
                            class="form-control box-input-span"
                            type="number"
                            id="amount"
                            name="amount"
                            formControlName="amount"
                            (change)="onChangeAmount('VES')"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'amount'), 'is-invalid': isInvalidField(expenseForm, 'amount') }"
                            finaBlurOnWheel
                        />
                        <span class="input-group-text form-control-solid span-input">{{ '$' }}</span>
                        <div class="invalid-feedback" *ngIf="isInvalidField(expenseForm, 'amount')">Debe asignar un monto.</div>
                    </div>
                </div>

                <div class="col-sm-6 mb-3 box-field" *ngIf="expenseForm.get('type')?.value === 'fixed'">
                    <label class="input-label" for="amountVES">Monto en Bs.</label>
                    <div class="input-group">
                        <input
                            class="form-control box-input-span"
                            type="number"
                            id="amountVES"
                            formControlName="amountVES"
                            (change)="onChangeAmount('USD')"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'amountVES'), 'is-invalid': isInvalidField(expenseForm, 'amountVES') }"
                            finaBlurOnWheel
                        />
                        <span class="input-group-text form-control-solid span-input">Bs.</span>
                        <div class="invalid-feedback" *ngIf="isInvalidField(expenseForm, 'amountVES')">Debe asignar un monto.</div>
                    </div>
                </div>

                <div class="mb-3 box-field" *ngIf="expenseForm.get('type')?.value === 'fixed'">
                    <label for="exchangeRate" class="input-label">Tasa de cambio</label>
                    <div class="input-group">
                        <input
                            class="form-control box-input-span"
                            type="number"
                            id="exchangeRate"
                            name="exchangeRate"
                            formControlName="exchangeRate"
                            (change)="onChangeAmount('VES')"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'exchangeRate'), 'is-invalid': isInvalidField(expenseForm, 'exchangeRate') }"
                            finaBlurOnWheel
                        />
                        <span class="input-group-text form-control-solid span-input">{{ 'Bs./$' }}</span>
                        <div class="invalid-feedback" *ngIf="expenseForm.get('exchangeRate')?.hasError('required')">Debe establecer una tasa de cambio.</div>
                        <div class="invalid-feedback" *ngIf="expenseForm.get('exchangeRate')?.value <= 0">Tasa de cambio inválida.</div>
                    </div>
                    <div class="text-exchange-rate">{{ rateLabel(expenseForm.get('exchangeRate')?.value) }}</div>
                </div>

                <!-- Fecha del registro -->
                <div class="mb-3 box-field" *ngIf="expenseForm.get('type')?.value === 'variable'">
                    <label for="registryDate" class="input-label">Fecha del pago</label>
                    <div class="input-group">
                        <input
                            class="form-control input-calendar"
                            oninput="validity.valid || (value=currentDate)"
                            id="registryDate"
                            name="registryDate"
                            ngbDatepicker
                            formControlName="registryDate"
                            #d="ngbDatepicker"
                            autocomplete="off"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'registryDate'), 'is-invalid': isInvalidField(expenseForm, 'registryDate') }"
                            [maxDate]="currentDate"
                        />
                        <button class="btn calendar" (click)="d.toggle()" type="button">
                            <img src="assets/icons/svg/calendar.svg" alt="Icono para seleccionar una fecha" class="btn p-0 icon-calendar" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="expenseForm.get('type')?.value === 'fixed'">
                <!-- Campo para elegir el día del mes a pagar -->
                <div class="col-sm-6 mb-3 box-field">
                    <label class="input-label" for="paymentDate">Dia del mes a pagar (Opcional)</label>
                    <div class="input-group">
                        <input
                            class="form-control input-calendar"
                            placeholder="yyyy-mm-dd"
                            oninput="validity.valid || (value='')"
                            id="paymentDate"
                            name="paymentDate"
                            ngbDatepicker
                            formControlName="paymentDate"
                            #d="ngbDatepicker"
                            autocomplete="off"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'paymentDate'), 'is-invalid': isInvalidField(expenseForm, 'paymentDate') }"
                            [minDate]="currentDate"
                        />
                        <button class="btn calendar" (click)="d.toggle()" type="button">
                            <img src="assets/icons/svg/calendar.svg" alt="Icono para seleccionar una fecha" class="btn p-0 icon-calendar" />
                        </button>
                    </div>
                </div>
                <!-- Campo para elegir la frecuencia de pago -->
                <div class="col-sm-6 mb-4 box-field">
                    <label for="paymentFrequency" class="input-label">Frecuencia de pago (Opcional)</label>
                    <div class="input-group">
                        <select
                            class="input-group form-select form-control box-input"
                            id="paymentFrequency"
                            name="paymentFrequency"
                            formControlName="paymentFrequency"
                            [ngClass]="{ 'is-valid': isValidField(expenseForm, 'paymentFrequency'), 'is-invalid': isInvalidField(expenseForm, 'paymentFrequency') }"
                        >
                            <option value="semanal">Semanal</option>
                            <option value="quincenal">Quincenal</option>
                            <option selected value="mensual">Mensual</option>
                            <option value="bimestral">Bimestral</option>
                            <option value="trimestral">Trimestral</option>
                            <option value="semestral">Semestral</option>
                            <option value="anual">Anual</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Cuenta bancarias -->
            <ng-container formArrayName="bankAccountData">
                <div *ngFor="let bankAccount of bankAccountData.controls; let i = index" [formGroupName]="i">
                    <div class="row position-relative">
                        <div *ngIf="i > 0">
                            <br />
                            <button class="btn text-danger position-absolute top-0 end-0 mt-4 me-1 p-2 fw-bolder" (click)="onRemoveBankAccount(i)" title="Remover método de pago">X</button>
                        </div>
                        <div class="col-sm-6 mb-3 box-field">
                            <label [for]="'selectedPM' + i" class="input-label">Método de pago</label>
                            <div class="input-group">
                                <select
                                    class="input-group form-select form-control rounded box-input"
                                    [id]="'selectedPM' + i"
                                    [name]="'selectedPM' + i"
                                    formControlName="selectedPM"
                                    (change)="onChangePM(i, $event.target.value)"
                                >
                                    <option disabled value="">Seleccione...</option>
                                    <option
                                        [hidden]="pm.name === 'CUENTA POR COBRAR' || pm.name === 'CUENTA POR PAGAR' || !pm.bankAccount || pm.type?.code === 'FINA-PAYMENTS'"
                                        *ngFor="let pm of fveService?.paymentMethods$ | async"
                                        [value]="pm._id"
                                    >
                                        {{ pm.name }}
                                        <span *ngIf="pm.bankAccount?.name"> ( {{ pm.bankAccount?.name }} ) </span>
                                    </option>
                                </select>
                                <div class="invalid-feedback" *ngIf="isInvalidField(bankAccount, 'selectedPM')">Debe seleccionar un método de pago.</div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 box-field">
                            <label [for]="'bankAccountUSDPayment' + i" class="input-label">Monto (USD)</label>
                            <div class="input-group">
                                <input
                                    class="form-control box-input-span"
                                    type="number"
                                    [id]="'bankAccountUSDPayment' + i"
                                    [name]="'bankAccountUSDPayment' + i"
                                    formControlName="bankAccountUSDPayment"
                                    (change)="onChangeBankAccountAmount({ index: i, currency: 'VES' })"
                                    [ngClass]="{
                                        'is-valid': isValidField(bankAccount, 'bankAccountUSDPayment'),
                                        'is-invalid': isInvalidField(bankAccount, 'bankAccountUSDPayment')
                                    }"
                                    finaBlurOnWheel
                                />
                                <span class="input-group-text form-control-solid span-input">{{ '$' }}</span>
                                <div class="invalid-feedback" *ngIf="isInvalidField(bankAccount, 'bankAccountUSDPayment')">Debe indicar un monto de pago.</div>
                                <div class="invalid-feedback" *ngIf="isInvalidField(bankAccount, 'bankAccountUSDPayment')">El monto debe ser mayor a cero.</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Tasa de cambio a usar -->
                        <div class="col-sm-6 mb-3 box-field">
                            <label [for]="'exchangeRate' + i" class="input-label">Tasa de cambio</label>
                            <div class="input-group">
                                <input
                                    class="form-control box-input-span"
                                    type="number"
                                    [id]="'exchangeRate' + i"
                                    [name]="'exchangeRate' + i"
                                    formControlName="exchangeRate"
                                    (change)="onChangeBankAccountAmount({ index: i, currency: 'VES' })"
                                    [ngClass]="{
                                        'is-valid': isValidField(bankAccount, 'exchangeRate'),
                                        'is-invalid': isInvalidField(bankAccount, 'exchangeRate')
                                    }"
                                    finaBlurOnWheel
                                />
                                <span class="input-group-text form-control-solid span-input">{{ 'Bs./$' }}</span>
                                <div class="invalid-feedback" *ngIf="isInvalidField(bankAccount, 'exchangeRate')">El monto debe ser mayor a cero.</div>
                            </div>
                            <div class="text-exchange-rate">{{ rateLabel(bankAccount.get('exchangeRate')?.value) }}</div>
                        </div>
                        <!-- Equivalencia en Bs. -->
                        <div class="col-sm-6 mb-3 box-field">
                            <label [for]="'bankAccountVESPayment' + i" class="input-label">Equivalente en Bolívares</label>
                            <div class="input-group">
                                <input
                                    class="form-control box-input-span"
                                    type="number"
                                    [id]="'bankAccountVESPayment' + i"
                                    [name]="'bankAccountVESPayment' + i"
                                    formControlName="bankAccountVESPayment"
                                    (change)="onChangeBankAccountAmount({ index: i, currency: 'USD' })"
                                    [ngClass]="{
                                        'is-valid': isValidField(bankAccount, 'bankAccountVESPayment'),
                                        'is-invalid': isInvalidField(bankAccount, 'bankAccountVESPayment')
                                    }"
                                    finaBlurOnWheel
                                />
                                <span class="input-group-text form-control-solid span-input">{{ 'Bs' }}</span>
                                <div class="invalid-feedback">El total a pagar excede el total disponible en la cuenta bancaria.</div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </ng-container>
            <div *ngIf="expenseForm.get('type')?.value === 'variable'" class="text-purple mt-2 pointer m-2 w-50" (click)="onAddBankAccount()">+ Agregar método de pago</div>

            <div class="row" *ngIf="expenseForm.get('type')?.value === 'variable'">
                <div class="col-sm-6 mb-3">
                    <p class="m-0">Total en USD: {{ expenseForm.get('amount')?.value }}</p>
                </div>

                <div class="col-sm-6 mb-3">
                    <p class="m-0">Total en Bs.: {{ expenseForm.get('amountVES')?.value }}</p>
                </div>
            </div>

            <!-- Campo descripcion -->
            <div class="row" *ngIf="expenseForm.get('type')?.value === 'variable'">
                <div class="col-sm-12 mb-3 box-field">
                    <label class="input-label" for="description">Descripción</label>
                    <textarea class="form-control box-input" type="text" id="description" name="description" formControlName="description" autocomplete="off"></textarea>
                </div>
            </div>

            <!-- Botón para confirmar el ingreso -->
            <div class="box-btn-submit">
                <button
                    class="btn btn-submit"
                    [disabled]="expenseForm.invalid || loading"
                    (click)="
                        save();
                        analyticsService.analyticsCapture(expenseForm.get('type')?.value === 'variable' ? 'add_variable_expense' : 'add_fixed_expense');
                        analyticsService.analyticsCapture('confirm_expense')
                    "
                >
                    {{ dataToUpdate === null ? 'Confirmar gasto' : 'Guardar cambios' }}
                </button>
            </div>
        </div>
    </ng-template>
</form>

<ng-template #modalMessageEdit let-modal>
    <div class="modal-header">
        <div class="modal-title">Editar gasto</div>
        <div class="box-btn-close-modal">
            <button (click)="modal.close('Close Click')" class="btn-close-modal rounded-circle" type="button" data-dismiss="modal" aria-label="Close">
                <img src="assets/icons/svg/icon-btn-close-modal.svg" class="" alt="Cerrar formulario de editar gasto" />
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="text-center">
                ¿Seguro que desea Editar este Gasto?. Esta edita la proxima fecha de pago y si el monto es modificado se modificaran los pagos "Expirados". Si no quieres modificar Gastos sin pagar te
                recomendamos crear un nuevo registro.
            </div>
        </div>
        <!-- Botón para eliminar el ingreso -->
        <div class="box-btn-submit">
            <button class="btn btn-purple" (click)="open(modalAddFixedVariableExpense, { size: 'lg', centered: true })">Confirmar</button>
        </div>
    </div>
</ng-template>

<ng-template #modalDeleteFixedVariableExpense let-modal>
    <div class="modal-header">
        <div class="modal-title">Eliminar gasto</div>
        <div class="box-btn-close-modal">
            <button (click)="modal.close('Close Click')" class="btn-close-modal rounded-circle" type="button" data-dismiss="modal" aria-label="Close">
                <img src="assets/icons/svg/icon-btn-close-modal.svg" class="" alt="Cerrar formulario de eliminar gasto" />
            </button>
        </div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="text-center">{{ dataToUpdate.pendingAccount ? 'Este gasto pertenece a una cuenta por pagar' : '' }} ¿Seguro que desea eliminar este Gasto?. Esta acción es irreversible.</div>
        </div>
        <!-- Botón para eliminar el ingreso -->
        <div class="box-btn-submit">
            <button class="btn btn-danger" [disabled]="expenseForm.invalid || loading" (click)="delete()">Confirmar</button>
        </div>
    </div>
</ng-template>
